import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=4b7f8490&scoped=true&"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=4b7f8490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f8490",
  null
  
)

export default component.exports